import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromOrganization from '../reducers/organization.reducer';

export const selectState = createFeatureSelector<fromOrganization.State>(
    fromOrganization.featureKey
);

export const getPasses = createSelector(selectState, (state) => state.passes);
export const getOrganization = createSelector(selectState, (state) => state.organization);
export const getUserOrganization = createSelector(selectState, (state) => state.userOrganization);
export const getUserOrganizationPoints = createSelector(selectState, (state) => state.userOrganizationPoints);
export const getActiveOrganization = createSelector(selectState, (state) => state.activeOrganization);
export const getJoinedOrganization = createSelector(selectState, (state) => state.recentJoinedOrg);
export const organizationContent = createSelector(selectState, (state) => state.organizationContent);
export const pendingFeedback = createSelector(selectState, (state) => state.pendingFeedback);
export const getActiveSendee = createSelector(selectState, (state) => state.activeSendee);
export const getAppointmentLocations = createSelector(selectState, (state) => state.appointmentLocation);